import { useEffect, useMemo, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { getQuery, setQuery } from '@i18n-ecom/lib/dist/commonjs/url';
import { ROLE_KEY, RoleType, RoleTypeString } from '@/constants';
import { useFeatureModel } from '../models';

export interface UseMenuOptions {
  type: RoleType;
}

export const useMenu = ({ type }: UseMenuOptions) => {
  const history = useHistory();
  const location = useLocation();
  const { menu, getPathFromContentsById, getPathFromFirst } = useFeatureModel();
  const contents = menu[type] || [];
  const [contentId, setContentId] = useState(
    +(getQuery(location.search, 'content_id')?.toString() || ''),
  );
  const defaultOpenKeys = useMemo(() => {
    if (contents.length) {
      let openKeys = getPathFromContentsById(contentId, contents);
      openKeys = openKeys?.length ? openKeys : getPathFromFirst(contents);

      if (openKeys[openKeys.length - 1] !== contentId) {
        setContentId(() => {
          const newId = openKeys[openKeys.length - 1];
          history.replace({
            search: setQuery(history.location.search, 'content_id', newId),
          });
          return newId;
        });
      }

      return openKeys.map(v => String(v));
    }

    return [];
  }, [contentId, contents]);
  const handleClick = (key: string) => {
    setContentId(() => {
      const newId = +key;
      history.push({
        search: setQuery(location.search, 'content_id', key),
      });
      return newId;
    });
  };

  useEffect(() => {
    const query = getQuery(location.search);

    if (query['menu']?.toString() === 'feature') {
      const role = query[ROLE_KEY]?.toString();

      if (role === RoleTypeString[type]) {
        history.replace({
          search: setQuery(location.search, 'content_id', contentId),
        });
      }
    }
  }, [location.search]);

  return {
    contentId: contentId.toString(),
    defaultOpenKeys,
    contents,
    handleClick,
  };
};
